<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Salarios</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Empleado</a>
        </li>
        <li class="breadcrumb-item active">Salarios</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">

            <button
              type="button"
              class="btn btn-theme"
              @click="openModal('pay_salary', '')"
            >Pagar salario</button>
            <button
              type="button"
              class="btn btn-theme"
              @click="openModal('anticipate_salary', '')"
            >Adelantar salario</button>
          </div>
        </div>
        <br>
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input
              id="inlineRadio5"
              v-model.trim="checkboxmanual"
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              value="1"
              @change="showSalaries(1, $route.query.item, checkboxmanual)"
            >
            <label class="form-check-label" for="inlineRadio2">Todos</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="inlineRadio1"
              v-model="checkboxmanual"
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              value="2"
              @change="showSalaries(1, $route.query.item, checkboxmanual)"
            >
            <label class="form-check-label" for="inlineRadio1">Pagados</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="inlineRadio2"
              v-model="checkboxmanual"
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              value="3"
              @change="showSalaries(1, $route.query.item, checkboxmanual)"
            >
            <label class="form-check-label" for="inlineRadio2">Sin pagar</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="inlineRadio3"
              v-model="checkboxmanual"
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              value="4"
              @change="showSalaries(1, $route.query.item, checkboxmanual)"
            >
            <label class="form-check-label" for="inlineRadio2">Pagando</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="inlineRadio4"
              v-model.trim="checkboxmanual"
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              value="5"
              @change="showSalaries(1, $route.query.item, checkboxmanual)"
            >
            <label class="form-check-label" for="inlineRadio2">Anulados</label>
          </div>
        </div>
      </div>
      <div class="card-body">
        <!-- Nueva tabla -->
        <table class="table table-responsive table-hover">
          <thead>
            <tr>
              <th>Salario</th>
              <th>Cantidad Restante</th>
              <th>Cantidad por pagos</th>
              <th>Pagos pendientes</th>
              <th>Fecha de pago</th>
              <th>Estado</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="salary in arraySalaries" :key="salary.id">
              <td v-text="mymoney(salary.fortnight)"/>
              <td v-text="mymoney(salary.discount_left)"/>
              <td v-text="mymoney(salary.amount_dues)"/>
              <td v-text="salary.dues"/>
              <td v-text="showDate(salary.salary_date)"/>
              <!-- <td v-text="`${ (client.gender == 1) ? 'Masculino' : 'Femenino' }`"/> -->
              <td>
                <span v-if="salary.state==1" class="btn btn-success btn-sm">Pagado</span>
                <span v-if="salary.state==2" class="btn btn-secondary btn-sm">Sin pagar</span>
                <span v-if="salary.state==3" class="btn btn-warning btn-sm">Pagando</span>
                <span v-if="salary.state==4" class="btn btn-danger btn-sm">Anulado</span>
              </td>
              <td>
                <template>
                  <div class="btn-group mr-2"
                       role="group"
                       aria-label="First group">
                    <button
                      v-tooltip.top-center="'Pagar adelanto'"
                      v-if="salary.state==2 || salary.state==3"
                      class="btn btn-success"
                      @click="openModal('pay_anticipate', salary)"
                    >
                      <i class="icon-fa icon-fa-plus-circle"/>
                    </button>
                    <button
                      v-tooltip.top-center="'Ver pagos'"
                      class="btn btn-primary"
                      @click="openModal('watch_payments', salary)"
                    >
                      <i class="icon-fa icon-fa-eye"/>
                    </button>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button
                      v-tooltip.top-center="'Anular'"
                      v-if="salary.state==1 || salary.state==2 || salary.state==3"
                      class="btn btn-danger"
                      @click="openModal('desactivate', salary)"
                    >
                      <i class="icon-fa icon-fa-trash" />
                    </button>

                    <button
                      v-tooltip.top-center="'Convalidar'"
                      v-else
                      :href="`#${salary.name}`"
                      class="btn btn-info"
                      @click="openModal('activate', salary)"
                    >
                      <i class="icon-fa icon-fa-check" />
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Paginación -->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, checkboxmanual)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- MODALES -->
      <!-- Modal ingresar salarios -->
      <sweet-modal ref="salaries_modal" :title="modalTitle" hide-close-button blocking>
        <sweet-modal-tab
          id="tab1"
          title="Datos del pago">
          <div class="form-group">
            <label>Cuenta</label>
            <div class="form-inline">
              <multiselect
                v-model="idaccount"
                :class="{ 'is-invalid': $v.idaccount.$error }"
                :options="accountArray"
                :close-on-select="true"
                :clear-on-select="false"
                :loading="isLoadingAccounts"
                :show-labels="false"
                label="name"
                track-by="id"
                placeholder="Buscar cuenta..."
                @input="cantidadAccount"
                @search-change="selectAccount"
              />
              <div v-if="$v.idaccount.$error">
                <span
                  v-if="!$v.idaccount.required"
                  class="help-block help-block-error"
                >La cuenta de retiro es requerida</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Cantidad de la cuenta</label>
            <input
              v-model="amountAccount"
              class="form-control"
              disabled
              @input="$v.amountAccount.$touch()"
            >
          </div>

          <div class="form-group">
            <label>Tipo de pago</label>
            <select :class="{ 'is-invalid': $v.paymentAccount.$error }" v-model.trim="paymentAccount" class="form-control" @input="$v.paymentAccount.$touch()">
              <option
                v-for="paymentAccount in arrayAccountPayments"
                :key="paymentAccount.id"
                :value="paymentAccount.id"
                v-text="paymentAccount.name"
              />
            </select>
            <div v-if="$v.paymentAccount.$error">
              <span
                v-if="!$v.paymentAccount.required"
                class="help-block help-block-error"
              >El tipo de pago es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Quíncena</label>
            <masked-input
              v-model.trim="fortnight"
              :class="{ 'is-invalid': $v.fortnight.$error }"
              :mask="mask_quetzal"
              :guide="false"
              :keep-char-positions="true"
              :show-mask="true" type="text"
              placeholder="Ingrese el sueldo quincenal"
              class="form-control"
              @input="$v.fortnight.$touch()" />

            <div v-if="$v.fortnight.$error">
              <span
                v-if="!$v.fortnight.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
              <span
                v-if="!$v.fortnight.min && parseFloat(converMaskToNumber(fortnight)) == 0.00"
                class="help-block help-block-error"
              >El valor no puede ser cero</span>
              <span
                v-if="!$v.fortnight.max && parseFloat(converMaskToNumber(fortnight)) > parseFloat(converMaskToNumber(amountAccount))"
                class="help-block help-block-error"
              >La cantidad de la quíncena no puede ser superior a la de la cuenta</span>
            </div>
          </div>

          <div class="form-group">
            <label>Fecha del pago</label>
            <datepicker :class="{ 'is-invalid': $v.salary_date.$error }" :format="customFormatter" v-model.trim="salary_date" :language="es" input-class="form-control" placeholder="Ingrese la fecha de pago de la quíncena" @input="$v.salary_date.$touch()" />
            <div v-if="$v.salary_date.$error">
              <span
                v-if="!$v.salary_date.required"
                class="help-block help-block-error"
              >La fecha del pago es requerida</span>
            </div>
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab
          id="tab2"
          title="Faltas">
          <div class="form-group">
            <div class="table table-responsive table-sm">
              <table class="table">
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fault in arrayFaults" :key="fault.id">
                    <td v-text="fault.description"/>
                    <td v-text="showDate(fault.fault_date)"/>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </sweet-modal-tab>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="tipoAccion == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveSalary()"
        >Guardar</button>
      </sweet-modal>
      <!-- Modal adelantar salarios -->
      <sweet-modal ref="anticipate_salary" :title="modalTitle" hide-close-button blocking>
        <sweet-modal-tab
          id="tab1"
          title="Datos del adelanto"
        >
          <div class="form-group">
            <label>Cuenta</label>
            <div class="form-inline">
              <multiselect
                v-model="idaccount"
                :class="{ 'is-invalid': $v.idaccount.$error }"
                :options="accountArray"
                :close-on-select="true"
                :clear-on-select="false"
                :loading="isLoadingAccounts"
                style="width: 100%"
                label="name"
                track-by="id"
                placeholder="Buscar Cuenta..."
                @input="cantidadAccount"
                @search-change="selectAccount"
              />
              <div v-if="$v.idaccount.$error">
                <span
                  v-if="!$v.idaccount.required"
                  class="help-block help-block-error"
                >La cuenta de retiro es requerida</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Cantidad de la cuenta</label>
            <input
              v-model="amountAccount"
              class="form-control"
              disabled
              @input="$v.amountAccount.$touch()"
            >
          </div>
          <div class="form-group">
            <label>Tipo de pago</label>
            <select :class="{ 'is-invalid': $v.paymentAccount.$error }" v-model.trim="paymentAccount" class="form-control" @input="$v.paymentAccount.$touch()">
              <option
                v-for="paymentAccount in arrayAccountPayments"
                :key="paymentAccount.id"
                :value="paymentAccount.id"
                v-text="paymentAccount.name"
              />
            </select>
            <div v-if="$v.paymentAccount.$error">
              <span
                v-if="!$v.paymentAccount.required"
                class="help-block help-block-error"
              >El tipo de pago es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Quíncena adelantada</label>
            <masked-input
              v-model.trim="fortnight"
              :class="{ 'is-invalid': $v.fortnight.$error }"
              :mask="mask_quetzal"
              :guide="false"
              :keep-char-positions="true"
              :show-mask="true" type="text"
              placeholder="Ingrese el sueldo quincenal a adelantar"
              class="form-control"
              @input="$v.fortnight.$touch()" />

            <div v-if="$v.fortnight.$error">
              <span
                v-if="!$v.fortnight.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
              <span
                v-if="!$v.fortnight.min && parseFloat(converMaskToNumber(fortnight)) == 0.00"
                class="help-block help-block-error"
              >El valor no puede ser cero</span>
              <span
                v-if="!$v.fortnight.max && parseFloat(converMaskToNumber(fortnight)) > parseFloat(converMaskToNumber(amountAccount))"
                class="help-block help-block-error"
              >La cantidad de la quíncena no puede ser superior a la de la cuenta</span>
            </div>
          </div>

          <div class="form-group">
            <label>Cantidad de pagos</label>
            <input
              :class="{ 'is-invalid': $v.dues.$error }"
              v-model.trim="dues"
              class="form-control"
              placeholder="Ingrese la cantidad de pagos"
              @input="duesFunction()"
            >
            <div v-if="$v.dues.$error">
              <span
                v-if="!$v.dues.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Descuento por salario</label>
            <input
              v-model.trim="amount_dues"
              class="form-control"
              readonly
            >
          </div>
          <div class="form-group">
            <label>Fecha del adelanto</label>
            <datepicker
              :class="{ 'is-invalid': $v.salary_date.$error }"
              :format="customFormatter" v-model.trim="salary_date"
              :language="es" input-class="form-control"
              placeholder="Seleccione la fecha del adelanto"
            />
            <div v-if="$v.salary_date.$error">
              <span
                v-if="!$v.salary_date.required"
                class="help-block help-block-error"
              >La fecha del adelanto es requerida</span>
            </div>
          </div>
        </sweet-modal-tab>
        <sweet-modal-tab
          id="tab2"
          title="Faltas">
          <div class="form-group">
            <div class="table table-responsive table-sm">
              <table class="table">
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fault in arrayFaults" :key="fault.id">
                    <td v-text="fault.description"/>
                    <td v-text="showDate(fault.fault_date)"/>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </sweet-modal-tab>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="tipoAccion == 2"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveSalary()"
        >Guardar</button>
      </sweet-modal>
      <!-- Modal pagar anticipo de salario -->
      <sweet-modal ref="pay_anticipate" :title="modalTitle" hide-close-button blocking>
        <div class="row">
          <div class="card-body">
            <div class="form-group">
              <label>Cantidad restante</label>
              <input
                v-model.trim="discount_left"
                class="form-control"
                readonly
              >
            </div>
            <div class="form-group">
              <label>Cantidad por pago</label>
              <input
                v-model.trim="amount_dues"
                class="form-control"
                readonly
              >
            </div>
            <div class="form-group">
              <label>Cantidad a pagar</label>
              <masked-input
                v-model.trim="amount"
                :class="{ 'is-invalid': $v.amount.$error }"
                :mask="mask_quetzal"
                :guide="false"
                :keep-char-positions="true"
                :show-mask="true" type="text"
                placeholder="Ingrese la cantidad a pagar"
                class="form-control"
                @input="$v.amount.$touch()"/>
              <div v-if="$v.amount.$error">
                <span
                  v-if="!$v.amount.required"
                  class="help-block help-block-error"
                >El campo es requerido</span>
                <span
                  v-if="!$v.amount.min && parseFloat(converMaskToNumber(amount)) === 0"
                  class="help-block help-block-error"
                >El valor no puede ser cero</span>
                <span
                  v-if="!$v.amount.max && parseFloat(converMaskToNumber(amount)) > parseFloat(converMaskToNumber(discount_left))"
                  class="help-block help-block-error"
                >La cantidad del pago no puede ser superior al adelanto restante</span>
              </div>
            </div>
            <div class="form-group">
              <label>Fecha del pago</label>
              <datepicker :class="{ 'is-invalid': $v.payment_date.$error }" :format="customFormatter" v-model.trim="payment_date" :language="es" input-class="form-control" placeholder="Ingrese la fecha del pago" @input="$v.payment_date.$touch()" />
              <div v-if="$v.payment_date.$error">
                <span
                  v-if="!$v.payment_date.required"
                  class="help-block help-block-error"
                >La fecha del pago es requerida</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="tipoAccion == 3"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="savePayment()"
        >Guardar pago</button>
      </sweet-modal>
      <sweet-modal ref="watch_payments" :title="modalTitle" hide-close-button blocking>
        <div class="form-group">
          <div class="table table-responsive table-sm">
            <table class="table">
              <thead>
                <tr>
                  <th>Cantidad pagada</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in arrayPayments" :key="payment.id">
                  <td v-text="mymoney(payment.amount)"/>
                  <td v-text="showDate(payment.payment_date)"/>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cerrar</button>
      </sweet-modal>
      <sweet-modal ref="state_modal" icon="info" hide-close-button blocking>
        {{ modalTitleState }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.state_modal.close()"
        >No</button>
        <button
          v-if="tipoAccion == 4"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="desactivateSalary()"
        >Si</button>
        <button
          v-if="tipoAccion == 5"
          slot="button"
          type="button"
          class="btn btn-success"
          @click="activateSalary()"
        >Si</button>
      </sweet-modal>
      <sweet-modal ref="no_salaries" icon="info" hide-close-button blocking>
        {{ 'Este salario no contiene pagos' }}
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cerrar</button>
      </sweet-modal>
    </div>
  </div>
</template>
<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import {xelacode} from '../../../helpers/xelacode'
import { es } from 'vuejs-datepicker/dist/locale'
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { required, maxValue, not, sameAs } from 'vuelidate/lib/validators'
import ladda from 'ladda'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Datepicker,
    Multiselect,
    'masked-input': MaskedInput
  },
  data () {
    return {
      es: es,
      // ! Cuentas
      isLoadingAccounts: false,
      amountAccount: 0,
      idaccount: null,
      accountArray: [],
      arrayAccountPayments: [],
      paymentAccount: null,
      // ! Pagar salario o adelantar
      arrayFaults: [],
      arraySalaries: [],
      fortnight: '',
      amount_dues: '',
      dues: '',
      salary_date: null,
      discount_left: '',
      stateSalary: 1,
      // ! Pagar adelanto
      arrayPayments: [],
      amount: '',
      payment_date: null,
      salary_id: 0,
      // ! Otros
      checkboxmanual: 1,
      tipoAccion: 1,
      modalTitle: '',
      modalTitleState: '',
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0
      },
      offset: 3,
      item: 'name',
      search: '',
      cero: 'Q 0',
      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      })
    }
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations () {
    if (parseFloat(this.converMaskToNumber(this.amount)) > parseFloat(this.converMaskToNumber(this.discount_left)) || parseFloat(this.converMaskToNumber(this.amount)) === 0) {
      return {
        fortnight: {
        },
        dues: {
        },
        amount: {
          required,
          max: maxValue(parseFloat(this.converMaskToNumber(this.discount_left)))
        },
        idaccount: {
        },
        paymentAccount: {
        },
        salary_date: {
        },
        payment_date: {
          required
        }
      }
    } else {
      if (parseFloat(this.converMaskToNumber(this.fortnight)) > parseFloat(this.converMaskToNumber(this.amountAccount))) {
        return {
          fortnight: {
            required,
            max: maxValue(parseFloat(this.converMaskToNumber(this.amountAccount)))
          },
          dues: {
            required
          },
          amount: {
            required
          },
          idaccount: {
            required
          },
          paymentAccount: {
            required
          },
          salary_date: {
            required
          },
          payment_date: {
            required
          }
        }
      } else {
        return {
          fortnight: {
            required,
            min: not(sameAs('cero'))
          },
          dues: {
            required
          },
          amount: {
            required,
            min: not(sameAs('cero'))
          },
          idaccount: {
            required
          },
          paymentAccount: {
            required
          },
          salary_date: {
            required
          },
          payment_date: {
            required
          }
        }
      }
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + this.offset * 2
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.showSalaries(1, this.$route.query.item, this.checkboxmanual)
  },
  methods: {
    duesFunction () {
      if (parseFloat(this.converMaskToNumber(this.fortnight)) > 0 && this.dues > 0) {
        this.amount_dues = this.mymoney(this.converMaskToNumber(this.fortnight) / this.dues)
      } else {
        this.amount_dues = 0
      }
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    showDate (date) {
      return moment(date).locale('es').format('LL')
    },
    changePage (page, checkboxmanual) {
      let me = this
      me.pagination.current_page = page
      me.showSalaries(page, this.$route.query.item, checkboxmanual)
    },
    // Mascara para el input
    converMaskToNumber (value) {
      var myNumber = ''
      for (var i = 0; i < value.length; i += 1) {
        if (value.charAt(i) === 'Q' || value.charAt(i) === ',' || value.charAt(i) === ' ') {
          continue
        } else {
          myNumber += value.charAt(i)
        }
      }
      return parseFloat(myNumber).toFixed(2)
    },
    // METHOD QUETZALES
    mymoney (value) {
      return xelacode.money(parseFloat(value))
    },
    cantidadAccount () {
      this.amountAccount = this.mymoney(this.idaccount.amount)
      this.arrayAccountPayments = this.idaccount.payments
    },
    selectAccount (filter) {
      let me = this
      var url = `/api/admin/account/getSelect?filter=${filter}`
      this.isLoadingAccounts = true
      // eslint-disable-next-line no-undef
      axios.get(url).then(function (response) {
        me.accountArray = response.data.data
        me.isLoadingAccounts = false
      })
        .catch(function (error) {
          console.log(error)
          me.isLoadingAccounts = false
        })
    },
    async showSalaries (page, id, checkboxmanual) {
      let me = this
      // eslint-disable-next-line no-unused-vars
      const response =
      // eslint-disable-next-line no-undef
      await axios.get(`/api/admin/salaries/get?page=${page}&id=${id}&checkboxmanual=${checkboxmanual}`)
        .then(function (response) {
          var respuesta = response.data
          me.arraySalaries = respuesta.salaries.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showPayments (id) {
      let me = this
      this.arrayPayments = []
      // eslint-disable-next-line no-unused-vars
      const response =
      // eslint-disable-next-line no-undef
      axios.get(`/api/admin/salaries/getPayments?id=${id}`)
        .then(function (response) {
          me.arrayPayments = response.data.payments
          if (me.arrayPayments.length === 0) {
            me.$refs.no_salaries.open()
          } else {
            me.$refs.watch_payments.open()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showFaults () {
      let me = this
      // eslint-disable-next-line no-unused-vars
      const response =
      // eslint-disable-next-line no-undef
      axios.get(`/api/admin/faults/select?id=${this.$route.query.item}`)
        .then(function (response) {
          var respuesta = response.data
          me.arrayFaults = respuesta.faults
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveSalary () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.tipoAccion === 1) {
        if (this.$v.salary_date.$invalid || this.$v.fortnight.$invalid || this.$v.idaccount.$invalid || this.$v.paymentAccount.$invalid) {
        // eslint-disable-next-line no-undef
          toastr.error('Revise los campos', 'Error')
        } else {
          l.start()
          // eslint-disable-next-line no-undef
          axios
            .post('/api/admin/salaries', {
              fortnight: this.converMaskToNumber(this.fortnight),
              state: this.stateSalary,
              amount_dues: 0,
              dues: 0,
              idemployee: this.$route.query.item,
              idaccount: this.idaccount.id,
              idpayment: this.paymentAccount,
              discount_left: 0,
              salary_date: this.customFormatter(this.salary_date)
            })
            .then(function (response) {
              // eslint-disable-next-line no-undef
              toastr.success(response.data.message, 'Éxito')
              l.stop()
              me.closeModal()
            })
            .catch(function () {
              l.stop()
              // eslint-disable-next-line no-undef
              toastr.error('Problemas en el servidor', 'Error')
            })
        }
      } else {
        if (this.$v.salary_date.$invalid || this.$v.fortnight.$invalid || this.$v.dues.$invalid || this.$v.idaccount.$invalid || this.$v.paymentAccount.$invalid) {
          // eslint-disable-next-line no-undef
          toastr.error('Revise los campos', 'Error')
        } else {
          l.start()
          // eslint-disable-next-line no-undef
          axios
            .post('/api/admin/salaries', {
              fortnight: this.converMaskToNumber(this.fortnight),
              state: this.stateSalary,
              amount_dues: this.converMaskToNumber(this.amount_dues),
              dues: this.dues,
              idemployee: this.$route.query.item,
              idaccount: this.idaccount.id,
              idpayment: this.paymentAccount,
              discount_left: this.converMaskToNumber(this.fortnight),
              salary_date: this.customFormatter(this.salary_date)
            })
            .then(function (response) {
            // eslint-disable-next-line no-undef
              toastr.success(response.data.message, 'Éxito')
              l.stop()
              me.closeModal()
            })
            .catch(function () {
              l.stop()
              // eslint-disable-next-line no-undef
              toastr.error('Problemas en el servidor', 'Error')
            })
        }
      }
    },
    savePayment () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.amount.$invalid || this.$v.payment_date.$invalid) {
        // eslint-disable-next-line no-undef
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        // eslint-disable-next-line no-undef
        axios
          .post('/api/admin/salaries/payment', {
            amount: this.converMaskToNumber(this.amount),
            idsalary: this.salary_id,
            state: this.stateSalary,
            payment_date: this.customFormatter(this.payment_date),
            idemployee: this.$route.query.item
          })
          .then(function (response) {
            // eslint-disable-next-line no-undef
            toastr.success(response.data.message, 'Éxito')
            l.stop()
            me.closeModal()
          })
          .catch(function () {
            l.stop()
            // eslint-disable-next-line no-undef
            toastr.error('Problemas en el servidor', 'Error')
          })
      }
    },
    activateSalary () {
      let me = this
      // eslint-disable-next-line no-undef
      axios
        .put('/api/admin/salaries/activate', {
          id: this.salary_id
        })
        .then(function (response) {
          // eslint-disable-next-line no-undef
          toastr.success('Falta convalidada', 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          // eslint-disable-next-line no-undef
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    desactivateSalary () {
      let me = this
      // eslint-disable-next-line no-undef
      axios
        .put('/api/admin/salaries/desactivate', {
          id: this.salary_id
        })
        .then(function (response) {
          // eslint-disable-next-line no-undef
          toastr.success('Falta anulada', 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          // eslint-disable-next-line no-undef
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    openModal (accion, data = []) {
      let me = this
      this.$v.$reset()
      switch (accion) {
        case 'pay_salary': {
          this.selectAccount('A')
          this.showFaults()
          me.$refs.salaries_modal.open()
          this.amountAccount = 0
          this.arrayAccountPayments = []
          this.paymentAccount = null
          this.idaccount = null
          this.fortnight = ''
          this.discount = ''
          this.dues = ''
          this.salary_date = /* new Date().toISOString().slice(0, 10) */''
          this.discount_left = ''
          this.amount_dues = ''
          this.stateSalary = 1
          this.tipoAccion = 1
          this.modalTitle = 'Pagar salario'
          break
        }
        case 'anticipate_salary': {
          this.selectAccount('A')
          this.showFaults()
          me.$refs.anticipate_salary.open()
          this.amountAccount = 0
          this.arrayAccountPayments = []
          this.paymentAccount = null
          this.idaccount = null
          this.fortnight = ''
          this.discount = ''
          this.dues = ''
          this.salary_date = /* new Date().toISOString().slice(0, 10) */''
          this.discount_left = ''
          this.stateSalary = 2
          this.tipoAccion = 2
          this.modalTitle = 'Adelantar salario'
          break
        }
        case 'pay_anticipate': {
          me.$refs.pay_anticipate.open()
          this.fortnight = this.mymoney(data['fortnight'])
          this.discount = this.mymoney(data['discount'])
          this.amount_dues = this.mymoney(data['amount_dues'])
          this.dues = data['dues']
          this.salary_date = data['salary_date']
          this.discount_left = this.mymoney(data['discount_left'])
          this.stateSalary = 3
          this.amount = ''
          this.payment_date = null
          this.salary_id = data['id']
          this.tipoAccion = 3
          this.modalTitle = 'Pagar adelanto'
          break
        }
        case 'watch_payments': {
          this.modalTitle = 'Pagos hechos'
          this.showPayments(data['id'])
          break
        }
        case 'desactivate': {
          me.$refs.state_modal.open()
          this.modalTitleState = '¿Desea anular este pago?'
          this.salary_id = data['id']
          this.tipoAccion = 4
          break
        }
        case 'activate': {
          me.$refs.state_modal.open()
          this.modalTitleState = '¿Desea convalidar este pago?'
          this.salary_id = data['id']
          this.tipoAccion = 5
          break
        }
      }
    },
    closeModal () {
      this.showSalaries(this.pagination.current_page, this.$route.query.item, this.checkboxmanual)
      this.$refs.salaries_modal.close()
      this.$refs.anticipate_salary.close()
      this.$refs.pay_anticipate.close()
      this.$refs.watch_payments.close()
      this.$refs.state_modal.close()
      this.$refs.no_salaries.close()
      this.$v.$reset()
      this.arrayAccountPayments = []
      this.paymentAccount = null
      this.amountAccount = 0
      this.idaccount = null
      this.fortnight = ''
      this.discount = ''
      this.amount_dues = ''
      this.dues = ''
      this.salary_date = null
      this.discount_left = ''
      this.stateSalary = 1
      this.amount = ''
      this.payment_date = null
      this.salary_id = 0
      this.modalTitle = ''
      this.modalTitleState = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/persons/Salary.vue